<template>
    <div>

        <div class="bar_title mb-8 shadow-lg">
            <p class="title_bar_text">Consultas</p>
            <p>Realiza tu búsqueda por <b>{{ document_type.label }}</b></p>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-10 gap-4 justify-center items-center mb-3">
            <v-select class="lg:col-span-2 w-full style-chooser" v-model="document_type" :options="options_documents" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="search_field1='';" />

            <input v-if="document_type.value == 'PanaPass'" class="lg:col-span-6 input_ena input_query shadow-lg" type="text" ref="search_field1" v-model="search_field1_panapass" @input="formatInput">
            <input v-else class="lg:col-span-6 input_ena input_query shadow-lg" type="text" ref="search_field1" v-model="search_field1">
            
            <vs-button class="lg:col-span-2 w-full" id="make_query" color="secondary" icon-pack="feather" icon="icon-search" @click="search_action()">Buscar</vs-button>
        </div>
        
        <div v-if="data_query.length > 0" class="text-center mb-5">
            <span v-if="new Date(data_query[0].transferDate) < new Date('2014-01-01')">Esta {{ document_type.label }} tiene registros anteriores al 2014</span>
        </div>

        <data_merged v-if="data_query.length > 0" ref="data_merged_component" :search_field1="search_field1" :data_query="data_query" :total="total" @get_search="get_search" />
        <!-- <div v-else class="font_title text-center mt-8" style="color: rgb(235, 154, 24);">
            No existen registros para {{ search_field1 }}
        </div> -->

    </div>
</template>
<script>
import Swal from 'sweetalert2';
import data_merged from './partials/data_merged.vue'
import axios from '@/axios'
export default {
    components: {
        data_merged
    },
    data() {
        return {
            document_type: {label: 'Cédula/Dni', value: 'ID'},
            data_query: [],
            options_documents: [{label: 'Cédula/Dni', value: 'ID'}, {label: 'Matrícula/Placa', value: 'Placa'}, {label: 'Panapass', value: 'PanaPass'}],
            sql_selected: '',
            config: null,
            total: 0,
            internalValue: '',
            search_field1: '',
        };
    },
    computed: {
        search_field1_panapass: {
            get() {
                if( this.document_type.value == 'PanaPass' ){
                    // Si internalValue está vacío, muestra una cadena vacía; de lo contrario, completa con ceros
                    return this.internalValue ? this.internalValue.padStart(10, '0') : '';
                }
            },
            set(value) {
                if( this.document_type.value == 'PanaPass' ){
                    // Elimina ceros a la izquierda y limita el valor a 10 caracteres
                    this.internalValue = value.replace(/^0+/, '').slice(0, 10);
                }
            }
        }
    },
    mounted() {
        this.config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.accessToken,
            },
        }
    },

    methods: {
        formatInput(event) {
            if( this.document_type.value == 'PanaPass' ){
                const value = event.target.value;
                // Actualiza el valor interno después de eliminar ceros a la izquierda y limitar la longitud
                this.displayValue = value;
                this.search_field1 = this.search_field1_panapass
            }
        },
        search_action(){
            if( this.document_type ){
                switch (this.document_type.value) {
                    case 'ID':
                        this.sql_selected = 'searchStep11ID'
                        break;
                    case 'Placa':
                        this.sql_selected = 'searchStep11Matricula'
                        if( this.search_field1.length != 6 ){
                            Swal.fire({ text: 'La placa debe tener 6 dígitos', icon: 'info' });
                            return
                        }
                        break;
                    case 'PanaPass':
                        this.sql_selected = 'searchStep11Panapass'
                        if( this.search_field1.length != 10 ){
                            Swal.fire({ text: 'El número de panapass debe tener 10 dígitos', icon: 'info' });
                            return
                        }
                        break;
                }
                
                this.get_search()
            }else{
                this.$vs.notify({ text: "Seleccione un tipo de documento antes de consultar", color: "warning" });
            }
        },
        get_search(){
            let me = this

            this.$vs.loading()
            axios
            .get(`auth/makeQuery?par_name=${this.sql_selected}&search_field1=${this.search_field1.toUpperCase()}`, this.config )
            .then(function (response) {
                if( response.data.length > 0 ){
                    if( new Date(response.data[0].transferDate) < new Date('2014-01-01') ){
                        Swal.fire({
                            icon: 'info',
                            title: 'Esta búsqueda tiene registros anteriores al 2014, desea visualizarlos?',
                            showCancelButton: true,
                            confirmButtonColor: '#21409A',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Visualizar',
                            cancelButtonText: 'Cancelar'
                        }).then((result) => {
                            if (result.isConfirmed) {
                               me.load_data(response.data) 
                            }else{
                                me.data_query = []
                            }
                        });
                    }else{
                          me.load_data(response.data)  
                    }
                }else{
                    me.data_query = []
                }
                me.$vs.loading.close()
            })
            .catch(function (error) {
                console.log(error)
                me.$vs.loading.close()
            })
        },
        load_data(data_query){
            let me = this
            me.data_query = data_query
            let subtotal = 0
            me.data_query.map(function(value, key) {
                subtotal += parseFloat(Math.abs(value.valorTotal_float))
                console.log('total '+key+': ' + me.total)
            })
            me.total = (subtotal/me.data_query.length).toFixed(2)
        }
        
    },
};
</script>
<style lang="scss" scoped>
    .bar_title{
        background-color: #21409A;
        border-radius: 10px;
        padding: 10px 10px 10px 20px;
        color: white;
        font-size: 2.3vh;
        font-weight: 300;
    }
</style>